import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import intl from 'react-intl-universal';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles, Typography, Box } from '@material-ui/core';
import { DefaultSettings, MainContext, radioButtonValues } from 'context';
import LoadingAnimation from 'components/LoadingAnimation';
import { isExistingMeeting, isOneTimeMeeting, isRoomSystem } from 'utils/meetingUtils';
import { lsGet, LsKey } from 'utils/localStorageUtils';
import { RootState } from 'redux/rootReducer';
import { Session } from 'redux/checkInSlice';
import { MeetingError } from 'components/MeetingError';
import { browserInfo } from 'utils/browserUtils';
import { Button } from '@lifesize/clients.mui-components';
import { isReadMode } from 'utils/officeJS/schedule';
import CircularProgress from 'components/CircularProgress';

const MeetNow = () => {
  const classes = useStyles();
  const {
    displayAppointmentForm,
    scheduleMeetingError,
    scheduleMeetingErrorDetails,
    setExistingMeeting,
    setRoomSystem,
    setOneTimeModerator,
    setOneTimeName,
    setRadioValue,
    creatingAppointment
  } = useContext(MainContext);
  const defaultSettings: DefaultSettings = JSON.parse(lsGet(LsKey.Settings) || '{}');
  const { meetingValue, meetingType } = defaultSettings;
  const session: Session = useSelector((state: RootState) => state.checkIn.session);
  const { extension: ownerExtension, displayName } = session;
  const invitation = useSelector((state: RootState) => state.invitation);
  const showGenerateQuickInviteButton = () => browserInfo.safari && isReadMode();

  useEffect(() => {
    // TS hack to avoid checking setter function before calling it.
    if (!setRadioValue || !setExistingMeeting || !setOneTimeModerator || !setOneTimeName || !setRoomSystem) return;
    if (!_isEmpty(defaultSettings)) {

      // Generating Invitation using existing meeting
      if (isExistingMeeting(meetingType)) {
        setExistingMeeting(meetingValue);
      }

      // Room Systems
      if (isRoomSystem(meetingType)) {
        setRoomSystem(meetingValue);
      }

      // One Time Meeting
      if (isOneTimeMeeting(meetingType)) {
        setOneTimeModerator({ extension: ownerExtension });
      }
    } else {
      setRadioValue(radioButtonValues.direct);
      setOneTimeName((meetingValue as string) || displayName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (invitation.body && !showGenerateQuickInviteButton()) displayAppointmentForm && displayAppointmentForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invitation]);

  return (
    <Box className={classes.container}>
      {!scheduleMeetingError && (
        <>
          {!showGenerateQuickInviteButton() && (
            <>
              <LoadingAnimation />
              <Typography className={classes.message} component="h1">
                {intl.get('generatingYourMeeting')}
              </Typography>
            </>
          )}
          {showGenerateQuickInviteButton() && (
            <Button
              id={'generatingMeeting'}
              data-testid="saveChangesBtn"
              disabled={creatingAppointment}
              color="primary"
              variant="contained"
              onClick={() => displayAppointmentForm && displayAppointmentForm()}
            >
              {intl.get('generateQuickInvite')}
              {creatingAppointment && <CircularProgress />}
            </Button>
          )}
        </>
      )}
      {scheduleMeetingError && (
        <MeetingError
          scheduleMeetingError={scheduleMeetingError}
          scheduleMeetingErrorDetails={scheduleMeetingErrorDetails}
        />
      )}
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  message: {
    top: 80,
    fontSize: '1.6rem',
    position: 'relative'
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    position: 'relative'
  }
}));
export default MeetNow;
